import { computed } from 'vue'
import { AvatarSize, AvatarVariant } from './types'

interface Params {
  size: keyof typeof AvatarSize
  variant: keyof typeof AvatarVariant
}

export default function ({ size, variant }: Params) {
  const classes = computed((): string[] => {
    const cls = []

    if (variant === AvatarVariant.colored)
      cls.push('text-white')

    else
      cls.push('text-gray-800')

    switch (size) {
      case AvatarSize.xxs:
        cls.push('w-4 h-4 text-[6.67px]')
        break
      case AvatarSize.xs:
        cls.push('w-6 h-6 text-[10px]')
        break
      case AvatarSize.sm:
        cls.push('w-8 h-8 text-sm')
        break
      case AvatarSize.md:
        cls.push('w-10 h-10 text-base')
        break
      case AvatarSize.lg:
        cls.push('w-12 h-12 text-lg')
        break
      case AvatarSize.xl:
        cls.push('w-14 h-14 text-xl')
        break
      case AvatarSize['2xl']:
        cls.push('w-16 h-16 text-2xl')
        break
    }

    return cls
  })

  return {
    classes,
  }
}
